/**
 * Compare MAS / Firestore record ids that may disagree on string vs number.
 * Framework-free; safe for Angular apps, Cloud Functions, and unit tests.
 */
export function masIdsEqual(a: unknown, b: unknown): boolean {
	return String(a ?? '') === String(b ?? '');
}
